import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c223ffe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20"
};
const _hoisted_2 = {
  class: "textC title"
};
const _hoisted_3 = {
  key: 0,
  class: "mt30"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString($setup.data.info.title), 1), _createVNode(_component_el_text, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info.content), 1)]),
    _: 1
  }), $setup.data.info.picList ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.info.picList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: "mb15"
    }, [_createVNode(_component_el_image, {
      src: item.picUrl,
      fit: _ctx.fit
    }, null, 8, ["src", "fit"])]);
  }), 128))])) : _createCommentVNode("", true)]);
}